// 登录相关接口

import { axiosPost } from "@/utils/request";

const urlDict = {
  login: "/ap-system/UserLogin",  // 登录
  logout: "/ap-system/logout",    // 退出
};

/**
 * 登录
 * @param {*} data 
 * @returns 
 */
export const login = (data) => {
  return axiosPost({
    url: urlDict.login,
    data: data,
  });
};


/**
 * 退出登录
 * @param {*} data 
 * @returns 
 */
export const logout = data => {
  return axiosPost({
    url: urlDict.logout,
    data: data,
  })
}

/**
 * 有 token 获取用户信息
 * @returns 
 */
export const getUserInfo = () => {
  return axiosPost({
    url: "/ap-system/findUserInfo",
  })
}
